import { saveAs } from 'file-saver';
import { detect } from 'detect-browser';
import jsPDF from 'jspdf';

export function generate_map_link(c_name, i_name, m_name) {
  return `./Configurations/${c_name}/maps/${i_name}_${m_name}.PNG`;
}

export function generate_base_link(c_name, c_style, combination) {
  return `./Configurations/${c_name}/${c_style}/${c_style}_${combination}.jpg`;
}

export function generate_social_link(r_name, p_type, combination, overlays) {
  const host = window.location.href.replace(window.location.hash, '');
  return `${host}#/${r_name}/${p_type}/${combination}/${overlays}`;
}

export function preload_image(url) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.src = url;
    image.onload = () => {
      resolve(image);
    };
    image.onerror = () => {
      reject();
    };
  });
}

export function print(doc) {
  if (!doc) return;

  const browser = detect();
  doc.autoPrint();

  const iframe = document.getElementById('iframe');

  switch (browser && browser.name) {
    case 'chrome':
    case 'edge':
      iframe.src = doc.output('bloburl');
      break;
    case 'firefox':
      window.open(doc.output('bloburl'));
      break;
    default:
      break;
  }
}

export function download(blob) {
  saveAs(blob, 'configurator.png');
}

export function generate_base64(url = '', has_background = false) {
  return new Promise((resolve, reject) => {
    if (url === '') {
      reject('Url cannot be empty!');
      return false;
    }

    let canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    const image = new Image();
    image.src = url;
    image.onload = () => {
      canvas.width = image.width + 30;
      canvas.height = image.height + 30;

      if (has_background) {
        ctx.fillStyle = '#eee';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
      }

      ctx.drawImage(image, 15, 15);

      resolve(canvas.toDataURL());
    };
  });
}

function _insert_selected_items(materials, doc, start_position, config_name) {
  return new Promise(resolve => {
    let length = materials.length;
    let counter = 0;

    let column_width = doc.internal.pageSize.getWidth() / 4;
    let x = 22;

    let loaded = [];
    for (let i = 0; i < length; i++) {
      const item = materials[i];
      const material_name = item.material[0].name;
      const url = generate_map_link(config_name, item.name, material_name);
      loaded.push(generate_base64(url, true));
    }

    Promise.all(loaded).then(material_base64s => {
      for (let i = 0; i < material_base64s.length; i++) {
        const item = materials[i];
        const material_name = item.material[0].name;
        const base64 = material_base64s[i];
        const multiple = i % 4;
        x = column_width * multiple + 22;

        if (i !== 0 && multiple === 0) {
          x = 22;
          start_position += 100;
        }

        counter++;

        doc.addImage(base64, 'PNG', x, start_position, 70, 70);

        const text_y_position = start_position + 80;
        const item_material_name = material_name.replace(/_/g, ' ');

        doc.setTextColor(250, 124, 120);
        doc.setFontType('bold');
        doc.text(item.name, x, text_y_position);

        doc.setTextColor(51, 51, 51);
        doc.setFontType('normal');
        doc.text(item_material_name, x, text_y_position + 10);

        if (counter === length) {
          resolve();
        }
      }
    });
  });
}

export function generate_pdf_doc(image, materials, config_name, price) {
  return new Promise(resolve => {
    let doc = new jsPDF({
      orientation: 'portrait',
      unit: 'px',
      format: 'a4',
    });

    const page_width = doc.internal.pageSize.getWidth();
    const page_height = doc.internal.pageSize.getHeight();
    const image_height = page_height - 375;

    doc.addImage(image, 'JPEG', 0, 0, page_width, image_height);

    let offset_y = image_height + 20;

    doc.setTextColor(250, 124, 120);
    doc.setFontType('bold');
    doc.text('KITCHEN CONFIGURATOR', 15, offset_y);

    doc.setTextColor(51, 51, 51);
    doc.setFontType('normal');
    doc.text('YOUR PERSONALIZED OPTIONS', 172, offset_y);

    doc.setFontSize(8.5);
    doc.text(
      'Please Note: Images and specifications are to be used as a guide only and are visual representations\nintended to portray the suppliers range of materials on the development and cannot be regarded as fact.\nAll information, specifications, renderings, visual representations and plans are correct at the time of\npublication. Revision Date: October 2018',
      130,
      page_height - 40
    );

    doc.setFontSize(10);
    offset_y += 10;

    _insert_selected_items(materials, doc, offset_y, config_name).then(() => {
      doc.setFillColor(250, 124, 120);
      doc.rect(245, page_height - 145, 181, 90, 'F');

      doc.setTextColor(255, 255, 255);
      doc.setFontType('bold');
      doc.setFontSize(10.5);
      doc.text(
        'ORDER TOTAL* (Including Options): £' + price,
        250,
        page_height - 135
      );

      doc.setFontSize(10);
      doc.text('Name:', 250, page_height - 120);

      doc.setFillColor(238, 238, 238);
      doc.rect(250, page_height - 115, 170, 20, 'F');

      doc.text('Date:', 250, page_height - 85);

      doc.setFillColor(238, 238, 238);
      doc.rect(250, page_height - 80, 170, 20, 'F');

      generate_base64('./Configurations/mycolour-dark.png').then(base64 => {
        doc.addImage(base64, 'PNG', 15, page_height - 40, 100, 20);

        resolve(doc);
      });
    });
  });
}
